import React, {useState, useEffect} from 'react';
import refreshIcon from '../img/refresh.png';
import Select from 'react-select';
import '../css/App.css';
import '../css/bootstrap.min.css';
import Time, {getComputerTime} from '../Time';
import Members from '../users/Members';
import Permissions from '../Permissions';
const axios = require('axios').default;


class NotificationCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      formPriority: 1,
      formText: "",
      formDate: "",
      formCheckBox: false,
      formCreatedTo: [],
      selectedUsers:[],
      selectedGroups:[],
      formLink:"",
      warning:"",
      members:[],
      groups:[]
    };
   this.createNotification = this.createNotification.bind(this);
   this.handleFormChange = this.handleFormChange.bind(this);
   this.getSelectedUsers = this.getSelectedUsers.bind(this);
   this.loadMembers = this.loadMembers.bind(this);
   this.loadGroups = this.loadGroups.bind(this);
  }


  //Gets the data from the form and send it to the database
  createNotification = async (e) =>{

    e.preventDefault();

    let employeesListFinal = this.state.selectedGroups;

    if(this.state.selectedGroups.length > 0){
      let groupsToLookFor = this.state.selectedGroups.toString();
      let getMembersFromGroup = await Permissions.getPermissionGroups(groupsToLookFor)

      console.log(getMembersFromGroup)

      let memberList = this.state.selectedUsers;

      for(let member of getMembersFromGroup){
        memberList.push(member.username)
      }

      //Eliminate duplicates from the array before sending the notifications
      let finalList = [...new Set(memberList)];
     
      employeesListFinal = finalList;

    }else{
      employeesListFinal = this.state.selectedUsers;
    }


    //Validade if user selected any Member or Group
    if(employeesListFinal.length < 1 && this.state.selectedUsers.length < 1){
      this.setState({warning:"You need to select at least one member for your notification"});
      return;
    }
    
    //Check Time.js to save what time this notification was created
    const timeDate = Time.getComputerTimeDate();
    
    //fetch the data to be sent for the database
    var formdata = new FormData();
    
    formdata.append("priority", this.state.formPriority);
    formdata.append("text", this.state.formText);
    formdata.append("link", this.state.formLink);
    formdata.append("createdTo", employeesListFinal);
    formdata.append("generatedBy", this.state.user);
    formdata.append("currentDateTime", timeDate);
    formdata.append("selectedDate", this.state.formDate);
    formdata.append("checkBox", this.state.formCheckBox);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/notifications/createnotification.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

      //Closes the window
      this.props.close();
    
  }

  //Everytime you type something on the form it updates the state of this component
  handleFormChange = (e) =>{
    //Checks if what you are changing is a checkbox
    if(e.target.id == "formCheckBox"){
      const check = this.state.formCheckBox;
      this.setState({formCheckBox: !check});
    }else{
      this.setState({[e.target.id]: e.target.value});
    } 
  }

  //This gets all the users selected and insert into the state
  getSelectedUsers = (selectedMembers) => {
    let selectedMembersList = [];
        for(let member of selectedMembers){
            selectedMembersList.push(member.value)
        }
    this.setState({selectedUsers: selectedMembersList});
  };

  //This gets all the groups selected and insert into the state
  getSelectedGroups = (selectedGroups) => {
    let selectedGroupsList = [];
        for(let group of selectedGroups){
            selectedGroupsList.push(group.value)
        }
    this.setState({selectedGroups: selectedGroupsList});
  };

  loadMembers = async() =>{
    let membersLoaded = await Members.getMembersSelectList();
    this.setState({members:membersLoaded})
  }

  loadGroups = async() =>{
    let groupsLoaded = await Permissions.getAllPermissions();
    let array = [];
    for(let group of groupsLoaded){
      array.push({value: group.groupName, label: group.groupName})
    }
    this.setState({groups:array})
  }

  //This runs when the dashboard opens
  componentDidMount(){
    let currentTimeDate = Time.getComputerTimeDate();
    this.setState({formDate:currentTimeDate})
    this.loadMembers();
    this.loadGroups();
  }
  

  render() {
    
    let selectedMembers;
    //These are the members available right now
    const members = this.state.members;

    //Builds the member selector
    const selectMembers =
        <Select closeMenuOnSelect={false} 
                isMulti 
                options={members}
                onChange={this.getSelectedUsers}
                value={selectedMembers}
        />
    
    let selectedGroups;
    //These are the members available right now
    const groups = this.state.groups;

    //Builds the member selector
    const selectGroups =
        <Select closeMenuOnSelect={false} 
                isMulti 
                options={groups}
                onChange={this.getSelectedGroups}
                value={selectedGroups}
        />
   
    return(
    <div>
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>Notification Creation</h3>
                  <form onSubmit={this.createNotification}>
                      <div className="row">
                          <div className='col-3'>
                            <div className="mb-3">
                              <label className="form-label">Priority</label>
                              <input defaultValue={this.state.formPriority} type="number" required className="form-control" id="formPriority" min="1" max="10" onChange={this.handleFormChange}></input>
                            </div>
                          </div>
                          <div className='col-9'>
                            <div className="mb-3">
                              <label className="form-label">Send Date</label>
                              <input defaultValue={this.state.formDate} onChange={this.handleFormChange} type="datetime-local" className="form-control" id="formDate" required></input>
                            </div>
                          </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Notification Text</label>
                        <textarea onChange={this.handleFormChange} className="form-control" id="formText" rows="3" required></textarea>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Notification Link (optional)</label>
                        <input type="text" onChange={this.handleFormChange} className="form-control" id="formLink" rows="3"></input>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Members</label>
                        {selectMembers}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Groups</label>
                        {selectGroups}
                      </div>
                      <div className="mb-3 form-check">
                        <input onChange={this.handleFormChange} type="checkbox" className="form-check-input" id="formCheckBox"></input>
                        <label className="form-check-label">Everybody needs to complete this task</label>
                      </div>
                      <div className="mb-3">
                        <div id="warning" className="form-text">{this.state.warning}</div>      
                      </div>
                    <button type="submit" className="btn btn-primary">Send Notification</button>
                  </form>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default NotificationCreator;